import styled, { css } from "styled-components";
import { NavLink as NavLinkUi } from "react-router-dom";

export const Navbar = styled("div")`
  background-color: ${({ theme }) => theme.colors.White};
  box-shadow: 0px 4px 10px 0px rgba(0,0,0,.1);
  padding: 3px 10px;
`;

export const Nav = styled("nav")`
  grid-area: nav;
`;

export const NavItems = styled("ul")`
  margin: 0px;
  padding: 0px;
  list-style: none;
  display: flex;
  justify-content: space-between;
`;

export const NavItem = styled("li")`
  padding-right: 0px;
`;

const Link = css`
  text-decoration: none;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  font-size: 12px;
  font-weight: 400;
  width: 100%;
  margin-bottom: 1px;
  padding: 0px 15px 0px;
  position: relative;
  border-radius: 0px 0px 0px 0px;
  transition: all 0.25s ease-in-out;
  color: ${(props) => props.theme.colors.White};

  &.no-styles {
    border: 0;
    margin: 0;
    background: transparent;

    &:before,
    &:after {
      display: none;
    }
  }

  &.active {
    background-color: ${(props) => props.theme.colors.LightBlue};
    color: ${(props) => props.theme.colors.Primary};

    i {
      &:before {
        background-color: ${(props) => props.theme.colors.Primary};
      }
    }

    .caret {
      transform: rotate(0deg);
    }
  }

  &:not(.active):hover {
    background-color: ${(props) => props.theme.colors.Black25};
    color: ${(props) => props.theme.colors.DarkGray};

    i {
      &:before {
        background-color: ${(props) => props.theme.colors.DarkGray};
      }
    }
  }

  span {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }
`;

export const ButtonLink = styled("button")`
  border: 0px;
  margin: 0px;
  background: none;
  cursor: pointer;
  ${Link}
`;

export const NavLink = styled(NavLinkUi)`
  ${Link}
`;

export const Caret = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease-in-out;
  transform: rotate(-180deg);
  width: 24px;
  height: 24px;

  &.active {
    transform: rotate(0deg);
  }
`;

export const DropdownMenu = styled("div") <{ amountItems; isActiveDropdown }>`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  height: ${({ amountItems }) => amountItems * 34 + 1}px;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
  opacity: ${({ isActiveDropdown }) => (isActiveDropdown ? 1 : 0)};
  max-height: ${({ isActiveDropdown, amountItems }) =>
    isActiveDropdown ? amountItems * 34 : 0}px;
`;

export const DropdownItem = styled("div")`
  min-width: 185px;
  margin-bottom: 1px;
`;

export const SubNavLink = styled(NavLinkUi)`
  text-decoration: none;
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  padding: 7px 10px;
  position: relative;
  border-radius: 12px;
  transition: all 0.25s ease-in-out;
  // color: ${(props) => props.theme.colors.Black};
  // background-color: white;

  span {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &.no-styles {
    border: 0;
    margin: 0;
    background: transparent;

    &:before,
    &:after {
      display: none;
    }
  }

  &.active {
    background-color: ${(props) => props.theme.colors.LightBlue};
    color: ${(props) => props.theme.colors.Primary};
  }

  &:not(.active):hover {
    background-color: ${(props) => props.theme.colors.Black25};
    color: ${(props) => props.theme.colors.DarkGray};
  }
`;
